import { useState, useReducer, useEffect } from 'react';
import { tournamentReducer, createInitialState, ACTIONS } from './components/utils/tournamentReducer.js';
import { TournamentProvider } from './components/TournamentContext.jsx';
import './App.css';
import WooltariCup from './components/WooltariCup';

function WooltariCupGame(props) {
  const { coverImage, coverImageMobile, locale, gameStartInstruction, token, eventName, loginUrl, loginToPlay } = props;
  const [isStarted, setIsStarted] = useState(false);
  const [candidates, setCandidates] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const [state, dispatch] = useReducer(tournamentReducer, createInitialState(props));

  const match = 16;

  // Load game data on mount (only if token exists)
  useEffect(() => {
    if (token && token.trim() !== '') {
      loadGameData();
    }
  }, [token]);

  useEffect(() => {
    if (isStarted && candidates.length >= match) {
      dispatch({
        type: ACTIONS.INITIALIZE_TOURNAMENT,
        payload: { props, candidates, tournamentSize: match },
      });
    }
  }, [isStarted, candidates, match]);

  const handleImgClick = () => {
    if (token && token.trim() !== '') {
      setIsStarted(true);
    }
  };

  const handleLogin = () => {
    window.location.href = loginUrl;
  };

  const loadGameData = async () => {
    setIsLoading(true);
    setLoadError(false);
    try {
      const response = await fetch('https://wooltaricup-qmlofqf3ja-uc.a.run.app', {
        method: 'GET',
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
          'x-campaign-id': 'wolrd-cup-2026',
          'x-game-state': 'init',
          // 'x-test-token': 'dnfxkflxptmxm',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Transform entries to candidates format
      if (data.campaign?.entries && Array.isArray(data.campaign.entries) && data.campaign.entries.length >= match) {
        const transformedCandidates = data.campaign.entries.map((entry) => ({
          id: entry.id,
          name: entry.title,
          nameEn: entry.titleEn || entry.title,
          img: entry.imgUrl,
          wins: entry.wins || 0,
        }));
        setCandidates(transformedCandidates);
      } else {
        throw new Error('Invalid data format or insufficient entries');
      }
    } catch (error) {
      console.error('Failed to load game data:', error);
      setLoadError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const hasToken = token && token.trim() !== '';

  if (!isStarted) {
    return (
      <div>
        <div className={hasToken ? "cursor-pointer" : ""} onClick={hasToken ? (isLoading || loadError ? undefined : handleImgClick) : undefined}>
          <img className="hidden md:block w-full h-auto" src={coverImage} />
          <img className="md:hidden w-full h-auto" src={coverImageMobile} />
          <p className="text-center text-sm md:text-2xl">
            {!hasToken
              ? locale === 'ko'
                ? '로그인 후 이용 가능합니다'
                : 'Login required to play'
              : isLoading
              ? locale === 'ko'
                ? '게임 데이터 로딩중...'
                : 'Loading game data...'
              : loadError
              ? locale === 'ko'
                ? '데이터 로딩 실패'
                : 'Failed to load data'
              : gameStartInstruction}
          </p>
        </div>

        {!hasToken ? (
          <div className="text-center mt-4">
            <button
              onClick={handleLogin}
              className="animate-pulse text-white px-6 py-3 rounded-lg font-bold transition-colors cursor-pointer"
              style={{ backgroundColor: '#EF4646' }}
              data-amp-event={eventName}
              data-amp-section="wooltari_cup_start"
              data-amp-title="wooltari_cup_start"
              data-track-event={eventName}
              data-track-category="wooltari_cup_start"
              data-track-label="wooltari_cup_start"
            >
              {loginToPlay || (locale === 'ko' ? '로그인하고 시작하기' : 'Login to Play')}
            </button>
          </div>
        ) : loadError ? (
          <div className="text-center mt-4">
            <button
              onClick={loadGameData}
              className="bg-red-500 text-white px-6 py-3 rounded-lg font-bold hover:bg-red-600 transition-colors"
            >
              {locale === 'ko' ? '다시 시도' : 'Retry'}
            </button>
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <TournamentProvider state={state}>
      <WooltariCup
        match={match}
        candidates={candidates}
        language={locale}
        state={state}
        dispatch={dispatch}
        {...props}
      />
    </TournamentProvider>
  );
}

export default WooltariCupGame;